<template>
    <div class="h-100 d-flex align-items-center">
        <div class="mx-auto text-center">
            <Alerta 
                :variant="'info'" 
                :texto="`<h5>Desculpe, este atendimento encontra-se expirado.</h5>`"
             />
        </div>
    </div>
</template>
<script setup>
import Alerta from "@/components/Alertas/Alerta.vue";
</script>
